import script from "./Check.vue?vue&type=script&setup=true&lang=js"
export * from "./Check.vue?vue&type=script&setup=true&lang=js"

import "./Check.vue?vue&type=style&index=0&id=5b1e8f16&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b1e8f16"]])

export default __exports__